import { RootState } from "@base/store";
import Button from "@components/atoms/button";
import Divider from "@components/atoms/divider";
import Header from "@components/molecules/header";
import Layout from "@components/molecules/layout";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { ConnectedProps, connect, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { gameDetailsActions } from "../game-details/gameDetails.slice";
import { PaymentIntentProps } from "../transactions/transaction.type";
import { transactionsActions } from "./transactionDetail.slice";
import {
  Content,
  DateText,
  DetailsInfoWrapper,
  DetailsWrapper,
  InfoTextName,
  InfoTextValue,
  InfoWrapper,
  Overview,
  OverviewTextWrapper,
  Subject,
  Title,
  Wrapper,
} from "./transactionDetail.styled";

import { ReactComponent as OutTransaction } from "@assets/images/transaction/out.svg";

type ReduxProps = ConnectedProps<typeof connector>;

const TransactionDetail = ({
  getIntentDetails,
  setSelectedGame,
  getGameById,
}: ReduxProps) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const user = useSelector((state: RootState) => state.user.user);

  const [trxDetails, setTrxDetails] = useState<PaymentIntentProps>();
  const [date, setDate] = useState<string>("");
  const amount = `${
    trxDetails?.amount! / 100
  } ${trxDetails?.currency.toUpperCase()}`;

  const infoRender = (title: string, value: string) => (
    <InfoWrapper>
      <InfoTextName>{title}</InfoTextName>
      <InfoTextValue>{value}</InfoTextValue>
    </InfoWrapper>
  );

  const getIntentsDetails = async () => {
    const response = await getIntentDetails(id!);
    if (response?.meta?.requestStatus === "fulfilled") {
      setTrxDetails(response?.payload);
    }
  };

  useEffect(() => {
    getIntentsDetails();
  }, []);

  useEffect(() => {
    if (trxDetails) {
      var inputDate = new Date(trxDetails?.created_at!);
      var day = inputDate.getUTCDate();
      var month = inputDate.getUTCMonth() + 1;
      var year = inputDate.getUTCFullYear() % 100;
      var formattedDate = `${day.toString().padStart(2, "0")}/${month
        .toString()
        .padStart(2, "0")}/${year.toString().padStart(2, "0")}`;
      setDate(formattedDate);
    }
  }, [trxDetails]);

  const supportEmailSubject: string = "Payment Inquiry";
  const supportEmailBody: string = `Dear rkbt support team,

I would like to inquire about the following payment:

  - Transaction ID: ${trxDetails?.id}
  - Payment ID: ${trxDetails?.payment_intent_id}

[please add details about your inquiry here]

Thank you,
${user?.firstName} ${user?.lastName}`;

  return (
    <Layout
      isLayout
      HeaderChildren={
        <Header
          title="Detail"
          handleBack={() => {
            navigate(-1);
          }}
        />
      }
      CardChildren={<></>}
    >
      {
        <>
          {trxDetails && (
            <Content>
              <DetailsWrapper>
                <DetailsInfoWrapper>
                  {infoRender("ID", trxDetails?.payment_intent_id)}
                  <Divider orientation="horizontal" />
                  {infoRender("Game", trxDetails?.game_rsvp.game.title!)}
                  <Divider orientation="horizontal" />
                  {infoRender("RSVP ID", trxDetails?.game_rsvp.id)}
                  <Divider orientation="horizontal" />
                  {infoRender(
                    "Timestamp",
                    dayjs(trxDetails?.created_at).toString()
                  )}
                  <Divider orientation="horizontal" />
                  {infoRender("Amount", amount)}
                  <Divider orientation="horizontal" />
                  {infoRender("Status", trxDetails?.status)}
                </DetailsInfoWrapper>
              </DetailsWrapper>
              <a
                target="_blank"
                href={`mailto:support@rkbt.ai?subject=${supportEmailSubject}&body=${encodeURIComponent(
                  supportEmailBody
                )}`}
              >
                Something Seems Off? Contact Us
              </a>
            </Content>
          )}
        </>
      }
    </Layout>
  );
};

const mapDispatchToProps = {
  fetchAccountLink: transactionsActions.fetchAccountLink,
  userHasStripeAccount: transactionsActions.userHasStripeAccount,
  createAccount: transactionsActions.createAccount,
  getIntentDetails: transactionsActions.getIntentDetails,
  getGameById: gameDetailsActions.getGameById,
  setSelectedGame: gameDetailsActions.setSelectedGame,
};

const connector = connect(undefined, mapDispatchToProps);
const TransactionsRedux = connector(TransactionDetail);

export { TransactionsRedux as TransactionDetail };
